import React, { useState } from "react"
import styled from "styled-components"

import config from "../../config"
import Layout from "../components/layout"
import SEO from "../components/seo"

const { seoTitleSuffix } = config

const PORTFOLIO_PASSWORD = "nike2026"
const PDF_PATH = "/portfolio/2026_BrandonRoegner_Nike_20260705.pdf"

const StyledSection = styled.section`
  width: 100%;
  max-width: 62.5rem;
  margin: 0 auto;
  padding: 0 2.5rem;
  height: auto;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background};
`

const Card = styled.div`
  width: 100%;
  max-width: 28rem;
  text-align: center;
`

const Title = styled.h1`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.primary};
`

const BrandName = styled.p`
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  opacity: 0.7;
`

const Subtitle = styled.p`
  font-size: 0.9rem;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.colors.primary};
  opacity: 0.8;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`

const Input = styled.input`
  width: 100%;
  max-width: 20rem;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius};
  background: transparent;
  color: ${({ theme }) => theme.colors.primary};
  outline: none;
  text-align: center;
  &::placeholder {
    color: ${({ theme }) => theme.colors.primary};
    opacity: 0.5;
  }
  &:focus {
    background: rgba(255, 255, 255, 0.1);
  }
`

const Button = styled.button`
  display: inline-block;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.background};
  background: ${({ theme }) => theme.colors.primary};
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.borderRadius};
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  &:hover {
    opacity: 0.85;
  }
`

const ErrorText = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 0.85rem;
  font-weight: bold;
`

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
    justify-content: center;
  }
`

const Portfolio = () => {
  const [password, setPassword] = useState("")
  const [unlocked, setUnlocked] = useState(false)
  const [error, setError] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (password === PORTFOLIO_PASSWORD) {
      setUnlocked(true)
      setError(false)
    } else {
      setError(true)
    }
  }

  return (
    <Layout splashScreen={false}>
      <SEO
        title={`Portfolio - ${seoTitleSuffix}`}
        meta={[{ name: "robots", content: "noindex" }]}
      />
      <StyledSection>
        <Card>
          {!unlocked ? (
            <>
              <BrandName>Everything Original&trade;</BrandName>
              <Title>Portfolio</Title>
              <Subtitle>Enter the password to access the portfolio.</Subtitle>
              <Form onSubmit={handleSubmit}>
                <Input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoFocus
                />
                {error && <ErrorText>Incorrect password. Try again.</ErrorText>}
                <Button type="submit">Unlock</Button>
              </Form>
            </>
          ) : (
            <>
              <BrandName>Everything Original&trade;</BrandName>
              <Title>Portfolio</Title>
              <Subtitle>You're in. View or download the portfolio below.</Subtitle>
              <ButtonGroup>
                <Button
                  as="a"
                  href={PDF_PATH}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View PDF
                </Button>
                <Button as="a" href={PDF_PATH} download>
                  Download PDF
                </Button>
              </ButtonGroup>
            </>
          )}
        </Card>
      </StyledSection>
    </Layout>
  )
}

export default Portfolio
